import React from "react";

function TablaTrabajadoresMunicipio() {
  return (
    <div className="tablaGrafica">
      <h5 class="tituloTabla">NUMERO DE TRABAJADORES POR MUNICIPIO</h5>
      <table>
        <thead>
          <tr>
            <th>MunicipioCT</th>
            <th>Trabajadores</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ASTACINGA</td>
            <td>7</td>
          </tr>
          <tr>
            <td>NANCHITAL DE LAZARO CARDENAS DEL RIO</td>
            <td>9</td>
          </tr>
          <tr>
            <td>SAN ANDRES TENEJAPAN</td>
            <td>10</td>
          </tr>
          <tr>
            <td>TUXTILLA</td>
            <td>10</td>
          </tr>
          <tr>
            <td>ZARAGOZA</td>
            <td>10</td>
          </tr>
          <tr>
            <td>TLACOTEPEC DE MEJIA</td>
            <td>12</td>
          </tr>
          <tr>
            <td>TEXCATEPEC</td>
            <td>13</td>
          </tr>
          <tr>
            <td>LANDERO Y COSS</td>
            <td>15</td>
          </tr>
          <tr>
            <td>AQUILA</td>
            <td>19</td>
          </tr>
          {/* Municipios adicionales de Veracruz */}
          <tr>
            <td>ACAYUCAN</td>
            <td>102</td>
          </tr>
          <tr>
            <td>COATZACOALCOS</td>
            <td>300</td>
          </tr>
          <tr>
            <td>MINATITLÁN</td>
            <td>187</td>
          </tr>
          <tr>
            <td>VERACRUZ</td>
            <td>563</td>
          </tr>
          <tr>
            <td>BOCA DEL RÍO</td>
            <td>210</td>
          </tr>
          <tr>
            <td>XALAPA</td>
            <td>400</td>
          </tr>
          <tr>
            <td>COATEPEC</td>
            <td>95</td>
          </tr>
          <tr>
            <td>PAPANTLA</td>
            <td>150</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td><strong>Total</strong></td>
            <td><strong>53509</strong></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default TablaTrabajadoresMunicipio;
